/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hub_Note_Export_TitleInputs */

const en_hub_note_export_title = /** @type {(inputs: Hub_Note_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export`)
};

const id_hub_note_export_title = /** @type {(inputs: Hub_Note_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ekspor`)
};

/**
* | output |
* | --- |
* | "Export" |
*
* @param {Hub_Note_Export_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const hub_note_export_title = /** @type {((inputs?: Hub_Note_Export_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hub_Note_Export_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_hub_note_export_title(inputs)
	return en_hub_note_export_title(inputs)
});